import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { a as u, s as v, t as C, u as g, v as z, j as D, w as y, x as I, y as P, z as j, A as k, B as F, C as w, D as B, d as H } from "../../vendor-Dd6qj6gJ.js";
import { layer as M } from "../../theme/layer.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as A } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as n } from "../BaseIcon/index.js";
import { FieldDescription as E } from "../FieldDescription/index.js";
import { FieldError as G } from "../FieldError/index.js";
import { FieldLabel as L } from "../FieldLabel/index.js";
import { c as a, C as O } from "../../CalendarHeader-B8Q81Mj_.js";
function R(r, c) {
  return r != null && c !== null && c !== void 0 && c.compare(r) < 0 ? r : c;
}
function S(r, c, o) {
  return r === null ? null : c != null && r.compare(c) < 0 ? c : o != null && r.compare(o) > 0 ? o : r;
}
function V({
  label: r,
  description: c,
  errorMessage: o,
  fullWidth: i = !1,
  horizontal: $ = !1,
  value: p,
  defaultValue: b,
  onChange: m,
  minValue: t,
  maxValue: h,
  ...l
}) {
  const [x, N] = u(
    p,
    b ?? null,
    m
  ), f = R(t, h);
  return /* @__PURE__ */ s(
    v,
    {
      ...A(l),
      value: x,
      onChange: (d) => N(S(d, t, f)),
      minValue: t,
      maxValue: f,
      className: H(a.datePicker, {
        [a.fullWidth]: i,
        [a.horizontal]: $
      }),
      "data-component": "DatePicker",
      children: [
        /* @__PURE__ */ e(L, { className: a.label, children: r }),
        /* @__PURE__ */ s(C, { className: a.fieldControl, children: [
          /* @__PURE__ */ e(n, { icon: "date", size: "sm", className: a.startIcon }),
          /* @__PURE__ */ e(g, { className: a.dateInput, children: (d) => /* @__PURE__ */ e(z, { segment: d, className: a.segment }) }),
          /* @__PURE__ */ e(D, { className: a.trigger, "aria-label": "Open calendar", children: /* @__PURE__ */ e(n, { icon: "chevron-down", size: "sm" }) })
        ] }),
        /* @__PURE__ */ e(E, { children: c }),
        /* @__PURE__ */ e(G, { children: o }),
        /* @__PURE__ */ e(
          y,
          {
            className: a.popover,
            style: { zIndex: M("menu") },
            placement: "bottom start",
            children: /* @__PURE__ */ e(I, { className: a.dialog, "aria-label": r ?? l["aria-label"], children: /* @__PURE__ */ s(P, { className: a.calendar, children: [
              /* @__PURE__ */ e(O, {}),
              /* @__PURE__ */ s(j, { className: a.calendarGrid, children: [
                /* @__PURE__ */ e(k, { children: (d) => /* @__PURE__ */ e(F, { className: a.calendarHeaderCell, children: d }) }),
                /* @__PURE__ */ e(w, { children: (d) => /* @__PURE__ */ e(B, { date: d, className: a.calendarCell }) })
              ] })
            ] }) })
          }
        )
      ]
    }
  );
}
export {
  V as DatePicker
};
